import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="border-t border-zinc-900/80 mt-32">
      <div className="mx-auto max-w-7xl px-6 py-12 grid grid-cols-2 gap-8 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="mt-3 text-sm text-zinc-500">
            24 plug-and-play hero backgrounds. One $79 purchase, lifetime access.
          </p>
        </div>
        <FooterCol title="Product" links={[["/effects", "All effects"], ["/try", "Live AI demo"], ["/pricing", "Pricing"], ["/changelog", "Changelog"]]} />
        <FooterCol title="Docs" links={[["/docs", "Getting started"], ["/docs/api", "API"], ["/llms.txt", "llms.txt"], ["/openapi.json", "OpenAPI"]]} />
        <FooterCol title="Legal" links={[["/legal/license", "License"], ["/legal/refund", "Refund policy"], ["/legal/privacy", "Privacy"], ["/legal/terms", "Terms"]]} />
      </div>
      <div className="border-t border-zinc-900/80 px-6 py-4 text-xs text-zinc-500 mx-auto max-w-7xl flex justify-between">
        <span>© {new Date().getFullYear()} HeroBG. Built on Cloudflare.</span>
        <span className="font-mono">v1.0.0</span>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }: { title: string; links: Array<[string, string]> }) {
  return (
    <div>
      <div className="mb-3 text-xs font-mono uppercase tracking-wider text-zinc-500">{title}</div>
      <ul className="space-y-1.5 text-sm">
        {links.map(([href, label]) => (
          <li key={href}>
            <Link to={href} className="text-zinc-300 hover:text-accent-300">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
